var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import useStream from '../../../../core/hooks/useStream';
import TextContent from '../../../../social/components/post/TextContent';
const TextContainer = styled.div `
  margin-bottom: 0.75rem;

  > :not(:first-child) {
    margin-top: 0.75rem;
  }
`;
const LivestreamContent = ({ streamId, mentionees = [] }) => {
    const stream = useStream(streamId);
    if (!stream.title && !stream.description) {
        return null;
    }
    // Mobile platforms also counts stream.title in their index
    // Since we're breaking description into another line, it is necessary
    // to compensate 2 more characters + the title to get correct index for mention highlight
    const descriptionMentionees = mentionees.map((_a) => {
        var _b;
        var { index } = _a, rest = __rest(_a, ["index"]);
        return (Object.assign({ index: index > ((_b = stream === null || stream === void 0 ? void 0 : stream.title) === null || _b === void 0 ? void 0 : _b.length) ? index - stream.title.length - 2 : index }, rest));
    });
    return (React.createElement(TextContainer, null,
        React.createElement("div", null, stream === null || stream === void 0 ? void 0 : stream.title),
        React.createElement(TextContent, { text: stream === null || stream === void 0 ? void 0 : stream.description, mentionees: descriptionMentionees })));
};
export default LivestreamContent;
//# sourceMappingURL=index.js.map